import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MessageService, SelectItem, Message} from 'primeng/api';
import {MensagensMeioAcessoEsqueciSenha} from "../../enum/mgs-meio-acesso.enum";
import {first} from "rxjs/operators";
import {Router, ActivatedRoute} from "@angular/router";
import {RedefinirSenhaService} from "../../services/esqueci-senha.service";
import {Beneficiario} from "../../shared/models/beneficiario.model";
import {AutenticacaoService} from "../../services/autenticacao.service";
import { ThemeService } from '../../services/theme.service';
import { BusinessService } from '../../services/business.service';

@Component({
  selector: 'app-recuperar-senha',
  templateUrl: './recuperar-senha.component.html',
  styleUrls: ['../login/login.component.scss'],
  providers: [MessageService]
})
export class RecuperarSenhaComponent implements OnInit {

  msgs: Message[] = [];
  formlogin: FormGroup;
  tiposLogin: SelectItem[];
  enumMensagens = MensagensMeioAcessoEsqueciSenha;
  beneficiario: Beneficiario;
  tipoLoginSelecionado: string;
  submitted: boolean;
  loading: boolean;

  constructor(private fb: FormBuilder, private messageService: MessageService,
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private businessService: BusinessService,
    private themeService: ThemeService,
    private redefinirSenhaService: RedefinirSenhaService,
    private autenticacaoService: AutenticacaoService) {
    this.autenticacaoService.logout();
    this.redefinirSenhaService.removerBeneficiarioLocalStorage();
  }

  ngOnInit() {
    this.formlogin = this.fb.group({
      login: new FormControl('', Validators.required),
      dtNascimento: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(10)])),
    });

    this.tipoLoginSelecionado = '3';

    this.tiposLogin = [
      {label: 'E-mail', value: '3'},
      {label: 'CPF', value: '1'},
      {label: 'Carteira', value: '2'},
    ];

    this.activatedRouter.queryParams.subscribe((params) => {
      const businessId = params['cod_empresa'];
      if (businessId) {
        this.setBusinessId(businessId);
        this.updateTheme(businessId);
      } else {
        this.setBusinessId('1');
        this.updateTheme('1');
      }
    });
  }

  onSubmit(value) {
    this.submitted = true;
    this.loading = true;
    this.messageService.clear();

    if (value.dtNascimento.length != 8) {
      this.loading = false;
      this.messageService.add({severity: 'warn', summary: 'Data inválida.'});
    } else if (this.tipoLoginSelecionado.endsWith("1") && value.login.length != 11) {
      this.loading = false;
      this.messageService.add({severity: 'warn', summary: 'CPF inválido.'});
    } else if (this.tipoLoginSelecionado.endsWith("2") && value.login.length != 14) {
      this.loading = false;
      this.messageService.add({severity: 'warn', summary: 'Número da carteira inválido.'});
    } else {
      let dtNascimento = value.dtNascimento.substr(0, 2) + '/' + value.dtNascimento.substr(2, 2) + '/' + value.dtNascimento.substr(4, 4);
      this.redefinirSenhaService.recuperarUsuario(value.login, dtNascimento, this.tipoLoginSelecionado).pipe(first()).subscribe((beneficiario) => {
          this.loading = false;
          if (beneficiario != null) {
            this.setBeneficiarioLocalStorage(beneficiario, dtNascimento);

            this.loading = true;
            this.messageService.clear();

            this.redefinirSenhaService.esqueciSenha(this.beneficiario.cdPessoa.toString(), this.beneficiario.telefone).subscribe(res => {
                this.loading = false;

                let response = {
                  statusToken: res.status == 201 ? true : false,
                  body: res.body
                }
                this.setResponseBeneficiarioLocalStorage(response);
                this.router.navigate(['./recuperar-senha-verificacao'], { queryParams: this.codEmpresaUrlParams()} );
              },
              error => {
                this.loading = false;
                if (error == "Unknown Error") {
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Estamos com problemas... Tente novamente em alguns instantes.'
                  });
                } else {
                  this.messageService.add({severity: 'warn', summary: 'Campo(s) inválido(s).'});
                }
              });
          } else {
            this.messageService.add({severity: 'warn', summary: 'Login e/ou data de nascimento inválido(s).'});
          }
        },
        error => {
          this.loading = false;
          if (error == "Unknown Error") {
            this.messageService.add({
              severity: 'error',
              summary: 'Estamos com problemas... Tente novamente em alguns instantes.'
            });
          } else {
            this.messageService.add({severity: 'warn', summary: 'Login e/ou data de nascimento inválido(s).'});
          }
        });
    }
  }

  setBeneficiarioLocalStorage(beneficiario: any, dtNascimento: string) {
    this.beneficiario = new Beneficiario();
    this.beneficiario.nome = beneficiario.nome;
    this.beneficiario.cpf = beneficiario.cpf;
    this.beneficiario.dtNascimento = dtNascimento;
    this.beneficiario.cdUsuario = beneficiario.cdUsuario;
    this.beneficiario.cdPessoa = beneficiario.cdPessoa;
    this.beneficiario.email = beneficiario.email;
    this.beneficiario.telefone = beneficiario.celular;
    this.beneficiario.meioAcesso = this.tipoLoginSelecionado;
    this.redefinirSenhaService.salvarBeneficiarioLocalStorage(this.beneficiario);
  }

  setResponseBeneficiarioLocalStorage(response: any) {
    this.beneficiario.responseToken = response;
    this.redefinirSenhaService.salvarBeneficiarioLocalStorage(this.beneficiario);
  }

  onChange(event) {
    this.formlogin.setValue({login: '', dtNascimento: ''});
  }

  setBusinessId(businessId: string) {
    this.businessService.setBusinessId(businessId);
  }

  getBusinessId() {
    return this.businessService.getBusinessId();
  }

  getSelectedTheme() {
    return this.themeService.getSelectedTheme();
  }

  updateTheme(businessId: string) {
    this.themeService.setSelectedTheme(businessId);
    this.themeService.updateTheme(businessId);
  }

  mostrarMsgChatHapvida() {
    return (this.businessService.getBusinessId() === "1");
  }

  codEmpresaUrlParams() {
    return (this.businessService.getBusinessId() === "1") ? {} : {cod_empresa: this.getBusinessId()};
  }
}
